<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="address_tel_fax">
      <span>地址：河北省廊坊市香河县平安大街99号</span>
      <span>Tel：13552717859</span>
    </p>
    <p class="email_wx">
      <span>邮箱：feedback@shengxiao.tech</span>
      <span>微信号：13552717859</span>
    </p>
    <p>
      <a style="color: yellow" href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2024072662号-1</a>
    </p>
    <p class="copy">Copyright &copy; 2024 - {{ new Date().getFullYear() }} 香河升啸科技有限责任公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue